import React, { PureComponent } from 'react';
//import PropTypes from 'prop-types';

import TdGrid from './TdGrid';
import { Row, Col } from 'antd';

class JadwalDokter extends PureComponent {

    buildMultilineData = (data) => {

        function generateUID() {
            var firstPart = (Math.random() * 46656) | 0;
            var secondPart = (Math.random() * 46656) | 0;
            firstPart = ("000" + firstPart.toString(36)).slice(-3);
            secondPart = ("000" + secondPart.toString(36)).slice(-3);
            return firstPart + secondPart;
        }

        return <div> {
            data.map((dt, i) => {
                return <div key={generateUID() + i}>{dt}</div>
            })
        }
        </div>
    }

    buildMultilineEmptyData = (data) => {
        
        function generateUID() {
            var firstPart = (Math.random() * 46656) | 0;
            var secondPart = (Math.random() * 46656) | 0;
            firstPart = ("000" + firstPart.toString(36)).slice(-3);
            secondPart = ("000" + secondPart.toString(36)).slice(-3);
            return firstPart + secondPart;
        }

        return <div> {
            data.map((dt, i) => {
                return <div style={{
                    visibility: 'hidden'
                }} key={generateUID() + i}>{dt}</div>
            })
        }
        </div>
    }

    render() {
        return (
            <div>
                {
                    this.props.data.map((val, i) => {
                        return (
                            <Row style={{
                                fontSize: this.props.fontSize,
                            }} key={'r_' + i}>

                                {/* <Col span={6} guttter={0}>
                                    <TdGrid align="left" odd={i % 2}>
                                        <div align="center">
                                            <img style={{
                                                width: 18*5,
                                                height: 18*5
                                            }}>
                                            </img>
                                        </div>
                                    </TdGrid>
                                </Col> */}

                                <Col span={12} guttter={0}>
                                    <TdGrid align="left" odd={i % 2}>{val.nama_dokter}
                                    {this.buildMultilineEmptyData([1,2,3,4,5])}
                                    </TdGrid>
                                </Col>

                                <Col span={4}>
                                    <TdGrid odd={i % 2}>{val.klinik}
                                    {this.buildMultilineEmptyData([1,2,3,4,5])}</TdGrid>
                                </Col>

                                <Col span={4}>
                                    <TdGrid odd={i % 2}>{this.buildMultilineData(val.jadwal_hari)}</TdGrid>
                                </Col>

                                <Col span={4}>
                                    <TdGrid odd={i % 2}>{this.buildMultilineData(val.jam)}</TdGrid>
                                </Col>
                            </Row>
                        )
                    })
                }
            </div>
        );
    }
}

JadwalDokter.propTypes = {

};

export default JadwalDokter;